/**
 * 회원가입 폼 상수 및 설정
 */

export const FORM_VALIDATION_RULES = {
  PHONE_REGEX: /^01[0-9]-?\d{3,4}-?\d{4}$/,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 8,
  USER_ID_MIN_LENGTH: 4,
};

export const ERROR_MESSAGES = {
  USERNAME_REQUIRED: "이름을 입력해주세요.",
  PHONE_REQUIRED: "휴대전화 번호를 입력해주세요.",
  PHONE_INVALID: "올바른 휴대전화 번호 형식이 아닙니다.",
  EMAIL_REQUIRED: "이메일을 입력해주세요.",
  EMAIL_INVALID: "올바른 이메일 형식이 아닙니다.",
  GENDER_REQUIRED: "성별을 선택해주세요.",
  USER_ID_REQUIRED: "아이디를 입력해주세요.",
  USER_ID_MIN_LENGTH: "아이디는 4자 이상이어야 합니다.",
  PASSWORD_REQUIRED: "비밀번호를 입력해주세요.",
  PASSWORD_MIN_LENGTH: "비밀번호는 8자 이상이어야 합니다.",
  PASSWORD_MISMATCH: "비밀번호가 일치하지 않습니다.",
  ADDRESS_REQUIRED: "주소를 입력해주세요.",
  ADDRESS_DETAIL_REQUIRED: "상세주소를 입력해주세요.",
  MANAGER_NAME_REQUIRED: "담당자 이름을 입력해주세요.",
  MANAGER_PHONE_REQUIRED: "담당자 전화번호를 입력해주세요.",
  MANAGER_PHONE_INVALID: "올바른 전화번호 형식이 아닙니다.",
  TERMS_REQUIRED: "이용약관에 동의해주세요.",
  PRIVACY_REQUIRED: "개인정보 수집에 동의해주세요.",
};
